module.exports = __webpack_public_path__ + "static/image_5-de4ef36500f69af8660c856039814630.jpg";